module.exports = __webpack_public_path__ + "img/case_pic02.7496bf0e.png";